import React from "react"
import L10n from "lib/carrot-l10n"
import { FlexRowCenter, Spacer } from "../../atoms/Atoms"
import { Body } from "../../atoms/Bodies"
import { ButtonPrimary } from "../../atoms/buttons/ButtonPrimary"
import { BenefitEnrollmentFlowModalBackButton, useBenefitEnrollmentFlow } from "./BenefitEnrollmentFlowModal"
import { IlloUnderwaterPlants } from "../../atoms/Illustrations"
import { Steps } from "./Workflow/Steps"
import { useHistory } from "react-router"
import { TextLink } from "../../atoms/links/TextLink"
import useSubmitWithErrorCatch from "./hooks/useSubmitWithErrorCatch"
import { useStateMachine } from "../../../context/stateMachine/StateMachineContext"
import { H2 } from "@carrotfertility/carotene"

const l = new L10n({ locale: "en-US" }).getBoundLocalize()
const ViewName = Steps.UNKNOWN_ERROR

export default function UnhandledEnrollmentErrorView({ unsetError }) {
  const history = useHistory()
  const { onExit } = useBenefitEnrollmentFlow()
  const { onSubmit } = useSubmitWithErrorCatch(() => {
    unsetError()
  })
  useStateMachine(ViewName, null)

  return (
    <>
      <div onClick={onSubmit}>
        <BenefitEnrollmentFlowModalBackButton />
      </div>
      <Spacer height={1.5} />
      <FlexRowCenter>
        <IlloUnderwaterPlants />
      </FlexRowCenter>
      <Spacer height={2} />
      <div className="flex flex-row justify-center">
        <H2 variant="dark">{l`An unknown error occurred.`}</H2>
      </div>
      <Spacer height={1} />
      <Body color="black-80">
        {l`We’re not sure what happened. Please go back and try again. If that doesn't 
        work, contact the `}
        <TextLink
          onClickOnly
          to="#"
          onClick={() =>
            history.push(
              "/talk-to-carrot/sendmessage/how-to-use-carrot/?enrollmentFlowError=enrollmentFlowUnknownError"
            )
          }
        >
          {l`Care Team for more support.`}
        </TextLink>
      </Body>
      <Spacer height={3} />
      <div className="flex flex-row justify-center">
        <ButtonPrimary onClick={onExit} enabled disabledBackgroundColor="black-10">
          {l`Close`}
        </ButtonPrimary>
      </div>
    </>
  )
}
